import * as z from "zod";
import { WebhookSchema } from "./base";
export const GetWebhookByPkResponseSchema = WebhookSchema.partial({
  credentials: true,
});

export type GetWebhookByPkResponse = z.infer<
  typeof GetWebhookByPkResponseSchema
>;
